import { useState } from 'react';

import Ajax from '../../../../../Handler/Ajax';
import classes from './PushVerification.module.scss';
import security from '../../../../../assets/img/security_shield.svg';
import Toast from '../../../../Form/Toast';


declare function Translate(key: string): string;
declare var _loginMethodSmsOtpUrl: any;

const PushVerification = (props) => {

    const [serverMessage,setServerMessage] = useState('');

    const updateDetailsClick = () => {
        Ajax.ResetUserStatus()
            .then(() => {                              
                window.location = _loginMethodSmsOtpUrl;
            })
            .catch((error) => {                   
                 setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));           
            });
    };

    const updateDetailsPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13){
            updateDetailsClick();
        }
    };


     return(
         <div className={classes.main}>
            {serverMessage.length > 0 && (
                <Toast message={serverMessage} />
            )}

            <img src={security} className={classes.img} alt="" />
            <div className={classes.title}>
                {Translate('N_General_unibeam_17')}
               
            </div>
            <div className={classes.desc}>
                {Translate('N_General_unibeam_18')}               
            </div>
             <div className={classes.desc}>
                <span>{Translate('N_General_unibeam_19')}</span>&nbsp;
                <span>{props.maskedEmail}</span>
            </div>
            <div className={`${classes.desc} ${classes.bold}`}>
            {Translate('N_General_unibeam_20')}
               
            </div>
           
           <div className={classes.bottomContainer}>
                    <hr />
                    <div className={classes.bottom}>
                        <div className={classes.bottomTitle}>{Translate('N_General_unibeam_21')}</div>
                        <div>{Translate('N_General_unibeam_22')}</div>
                        <div>{Translate('N_General_unibeam_23')}</div>
                        <div className={classes.linkContainer}>
                            <a  id='backToLoginLink' 
                                className={classes.link} 
                                onClick={updateDetailsClick}
                                onKeyPress={updateDetailsPress}
                                tabIndex={0}               
                            >
                                {Translate('N_General_unibeam_24')}
                            </a> 
                        </div>      
                    </div>
                </div>
        </div>
    );
};
export default PushVerification;